// Hero.jsx - Single-screen priority, immediate clarity + action
import React from 'react';
import './Hero.css';

const TRUST_BULLETS = [
  {
    text: 'No subscriptions required',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="10" />
        <path d="M8 12h8" />
      </svg>
    ),
  },
  {
    text: 'New models added constantly',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
      </svg>
    ),
  },
  {
    text: 'Works on mobile & desktop',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="5" y="2" width="14" height="20" rx="2" />
        <path d="M12 18h.01" />
      </svg>
    ),
  },
];

const Hero = () => {
  const handleStartCreating = () => {
    window.location.href = 'https://account.fluxuro.ai';
  };

  const handleBrowseWorkflows = () => {
    document.getElementById('workflows')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="hero-section">
      {/* Animated collage background */}
      <div className="hero-collage-bg" aria-hidden="true">
        <div className="hero-collage-track">
          <img 
            src="/images/demo/hero_collage.webp" 
            alt="" 
            className="hero-collage-image"
          />
          <img 
            src="/images/demo/hero_collage.webp" 
            alt="" 
            className="hero-collage-image"
          />
        </div>
      </div>
      <div className="hero-mockup">
        <img 
          src="/images/demo/zen_editor_showcase.png" 
          alt="URO Zen" 
          className="hero-mockup-image"
        />
      </div>
      <div className="hero-content">
        <h1 className="hero-headline">
          Create. Edit. Animate.
          <span className="hero-headline-accent">All in one place.</span>
        </h1>
        
        <p className="hero-subhead">
          Images, edits, and AI video — powered by top models and one-tap workflows.
        </p>

        <div className="hero-ctas">
          <button className="btn-primary hero-cta-primary" onClick={handleStartCreating}>
            Start Creating
          </button>
          <button className="btn-secondary hero-cta-secondary" onClick={handleBrowseWorkflows}>
            Browse Workflows
          </button>
        </div>

        <div className="hero-trust-bullets">
          {TRUST_BULLETS.map((bullet, index) => (
            <span key={index} className="trust-bullet">
              {bullet.icon}
              {bullet.text}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
